import API from '../api'
import postUrl from './paths'

export const submitReceivingAcknowledgement = (receivingAcknowledgement) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.submitReceivingAcknowledgement, receivingAcknowledgement)
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})
